import ForgottenPasswordCard from "../../components/common/cards/ForgottenPasswordCard";


type Props = {}

const ForgottenPasswordPage = (props: Props) => {
  return <ForgottenPasswordCard />;
};

export default ForgottenPasswordPage;
